import { Capacitor } from '@capacitor/core';
import appHttp from './app';
import h5Http from './h5';

const platform = Capacitor.getPlatform(); // web、ios 或 android
const httpClient = platform === 'web' ? h5Http : appHttp;

export const postRequest = httpClient.postRequest;
export const getRequest = httpClient.getRequest;
export const putRequest = httpClient.putRequest;
export const delRequest = httpClient.delRequest;
export const getBlobRequest = httpClient.getBlobRequest;

export default httpClient;
